// Generated by CoffeeScript 2.7.0

// ==============================================================================
// MODULES - LAYOUTS - HEADER
// ==============================================================================
import $ from "jquery";

$(function() {
  // ----------------------------------------------------------------------------
  // Hamburger Action Button for SP
  // ----------------------------------------------------------------------------
  (() => {
    var $headerNavSp, closeHeaderNavigation;
    $headerNavSp = $('#JS--headerNav_sp');
    // Define methods
    closeHeaderNavigation = function($headerNavSp) {
      $headerNavSp.hide();
      return $('html, body').removeAttr('style').ready(function() {
        return $(window).scrollTop(window.posY);
      });
    };
    // Open a header navigation
    $('#JS--header_hamburger_open').on('click', function(e) {
      e.preventDefault();
      $headerNavSp.show();
      window.posY = $(window).scrollTop();
      return $('html, body').css({
        height: '100%',
        overflow: 'hidden'
      });
    });
    // Close a header navigation
    $('#JS--header_hamburger_close').on('click', function(e) {
      e.preventDefault();
      return closeHeaderNavigation($headerNavSp);
    });
    // Set detecting resize event
    return this.detectResize.addFunction('pc', closeHeaderNavigation, $headerNavSp);
  })();
  // ----------------------------------------------------------------------------
  // Switch Subjects Screen for SP
  // ----------------------------------------------------------------------------
  (() => {
    var $headerNavSpSubjects, headerNavSpSubjects;
    headerNavSpSubjects = '#JS--headerNav_sp_subject';
    $headerNavSpSubjects = $(headerNavSpSubjects);
    return $headerNavSpSubjects.find('a').on('click', function(e) {
      var $this, index, navBody, subject;
      e.preventDefault();
      // Set variables
      $this = $(this);
      subject = $this.attr('data-subject');
      index = $this.index(`${headerNavSpSubjects} > a`) + 1;
      // Change status
      $(`${headerNavSpSubjects} > a`).removeClass('is_active');
      $(`${headerNavSpSubjects} > a:nth-child(${index})`).addClass('is_active');
      // Switch
      navBody = '.C--headerNav_sp_body';
      $(navBody).hide();
      return $(`${navBody}[data-subject=\"${subject}\"]`).show();
    });
  })();
  // ----------------------------------------------------------------------------
  // Show the fixed global header for PC
  // ----------------------------------------------------------------------------
  (() => {
    var readyHeader, showHeader;
    showHeader = function() {
      var $header, top;
      top = $(window).scrollTop();
      $header = $('#JS--header');
      if (top > 300) {
        return $header.css({
          position: 'fixed',
          zIndex: 10
        });
      } else if ($header.css('position') === 'fixed') {
        return $header.removeAttr('style');
      }
    };
    readyHeader = function(isOn = true) {
      if (isOn) {
        showHeader();
        return $(window).on('load scroll', showHeader);
      } else {
        $('#JS--header').removeAttr('style');
        return $(window).off('load scroll', showHeader);
      }
    };
    // Set detecting resize event
    this.detectResize.addFunction('pc', readyHeader, true);
    return this.detectResize.addFunction('sp', readyHeader, false);
  })();
  // ----------------------------------------------------------------------------
  // Switch Subjects Screen for PC
  // ----------------------------------------------------------------------------
  // Open Popup Window
  (() => {
    var $headerNavPc, $headerNavPcWindow, closeNavigation, headerNavPc, navBody;
    window.sujectOpenNum = 0;
    headerNavPc = '#JS--headerNav_pc';
    $headerNavPc = $(headerNavPc);
    $headerNavPcWindow = $('#JS--headerNav_pc_window');
    navBody = '.C--headerNav_pc_wrapper';
    // Define methods
    closeNavigation = function($headerNavPcWindow, navBody) {
      $headerNavPc.find('header > a').removeClass('is_active');
      $headerNavPcWindow.find(navBody).removeClass('do_show');
      return 0;
    };
    $headerNavPc.find('header > a').on('click', function(e) {
      var $currentNavBody, $this, index, subject;
      e.preventDefault();
      e.stopPropagation();
      // Set variables
      $this = $(this);
      subject = $this.attr('data-subject');
      index = $this.index(`${headerNavPc} header > a`) + 1;
      // If it's already opened, close a window
      if (window.sujectOpenNum === index) {
        window.sujectOpenNum = closeNavigation($headerNavPcWindow, navBody);
        return;
      }
      // Remove displayed status for each elements
      $headerNavPcWindow.removeClass('do_hide');
      $headerNavPc.find('header > a').removeClass('is_active');
      $headerNavPcWindow.find(navBody).removeClass('do_show');
      // Display new navigation and its contents
      $currentNavBody = $headerNavPcWindow.find(`${navBody}[data-subject=\"${subject}\"]`);
      $currentNavBody.addClass('do_show');
      $currentNavBody.find('.C--headerNav_pc_sideBar > div').removeClass('is_active');
      $currentNavBody.find('.C--headerNav_pc_content').removeClass('do_show');
      $currentNavBody.find('.C--headerNav_pc_sideBar > div:first-child').addClass('is_active');
      $currentNavBody.find('.C--headerNav_pc_content:first-child').addClass('do_show');
      // Set active status
      window.sujectOpenNum = index;
      return $(this).addClass('is_active');
    });
    // Close outside of a window
    $(document).on('click', function(e) {
      if (!window.sujectOpenNum) {
        return;
      }
      if (!$.contains($headerNavPcWindow[0], e.target)) {
        return window.sujectOpenNum = closeNavigation($headerNavPcWindow, navBody);
      }
    });
    // Set detecting resize event
    return this.detectResize.addFunction('sp', function() {
      return window.sujectOpenNum = closeNavigation($headerNavPcWindow, navBody);
    });
  })();
  // Switch contents in the left pane
  return (() => {
    return $('.C--headerNav_pc_sideBar > div').on('click', function(e) {
      var $this, $thisNav, identifiedKey;
      e.preventDefault();
      e.stopPropagation();
      // Set variables
      $this = $(this);
      identifiedKey = $this.attr('data-sub-subject');
      $thisNav = $this.parent().parent();
      // Set active status to a sidebar navigation
      $thisNav.find('.C--headerNav_pc_sideBar > div').removeClass('is_active');
      $this.addClass('is_active');
      // Show content from the identified key name
      $thisNav.find('.C--headerNav_pc_content').removeClass('do_show');
      return $thisNav.find(`.C--headerNav_pc_content[data-sub-subject=\"${identifiedKey}\"]`).addClass('do_show');
    });
  })();
});
